import React from 'react';
import './Section2.css'
import { Link } from 'react-router-dom';

const Section2 = () => {

  return (
    <section className="rooms1 section-padding bg-cream" data-scroll-index="1">
      <div className="container">
        <div className="row">
          <div className="col-md-12">
            <div className="section-subtitle">Alojamiento</div>
            <div className="section-title">Cabañas</div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-6">
            <div className="item">
              <div className="position-re o-hidden">
                <img src="/ecoCabaña.jpg" alt="Xata Aire - Vista al Mar" className="img-fluid" style={{  maxWidth: "100%", height: "auto", maxHeight: "541px" }}  />
              </div>
              <span className="category">
                <a href="https://wa.me/573188959559">Reservar</a>
              </span>
              <div className="con">
                <h5><Link to="/cabaña_vista_al_mar">Cabaña vista al mar</Link></h5>
                <div className="line"></div>
                <div className="row facilities">
                  <div className="col col-md-5 text-right">
                    <div className="permalink">
                    <Link to="/cabaña_vista_al_mar">Detalles <i className="bi bi-arrow-right"></i></Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="col-md-6">
            <div className="item">
              <div className="position-re o-hidden">
                <img src="/sec2_cp.jpeg" alt="Xata Aire - Vista al Jardín" className="img-fluid" style={{  maxWidth: "100%", height: "541px", maxHeight: "541px" }} />
              </div>
              <span className="category">
                <a href="https://wa.me/573188959559">Reservar</a>
              </span>
              <div className="con">
                <h5><Link to="/cabaña_la_portuguesa">Cabaña la portuguesa</Link></h5>
                <div className="line"></div>
                <div className="row facilities">
                  <div className="col col-md-5 text-right">
                    <div className="permalink">
                    <Link to="/cabaña_la_portuguesa">Detalles <i className="bi bi-arrow-right"></i></Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>
  )
}

export default Section2
